(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/marketplace-competition/overview-hero/assets/javascripts/content/competition-open-draw-live.js') >= 0) return;  svs.modules.push('/components/marketplace-competition/overview-hero/assets/javascripts/content/competition-open-draw-live.js');

'use strict';

const _React = React,
  useMemo = _React.useMemo;
const clx = svs.components.lbUtils.clx;
const _svs$components$marke = svs.components.marketplaceCompetition.overviewHero.common,
  CompetitionLogo = _svs$components$marke.CompetitionLogo,
  LoginButton = _svs$components$marke.LoginButton,
  Registration = _svs$components$marke.Registration,
  VisitGameButton = _svs$components$marke.VisitGameButton;
const resolveCompetitionName = svs.components.marketplaceCompetition.helpers.resolveCompetitionName;
const ordinalNumber = svs.components.marketplaceCompetition.overviewHero.helpers.ordinalNumber;
const _svs$components$marke2 = svs.components.marketplaceCompetition.overviewHero.constants.OverviewUserState,
  IS_NOT_REGISTERED = _svs$components$marke2.IS_NOT_REGISTERED,
  HAS_NO_CURRENT_BET = _svs$components$marke2.HAS_NO_CURRENT_BET,
  HAS_CURRENT_BET = _svs$components$marke2.HAS_CURRENT_BET;
const UserNotLoggedIn = _ref => {
  let competition = _ref.competition,
    compName = _ref.compName;
  return React.createElement(React.Fragment, null, React.createElement(CompetitionLogo, {
    competition: competition
  }), React.createElement("div", {
    className: "competition-overview-hero-content"
  }, React.createElement("h2", {
    className: "overview-hero-title"
  }, React.createElement("span", null, "".concat(compName, " \xE4r h\xE4r!"))), React.createElement("p", {
    className: "overview-hero-sub"
  }, React.createElement("span", null, "Var med och sl\xE5ss om titeln")), React.createElement(LoginButton, {
    isVisible: true
  })));
};
const UserNotRegistered = _ref2 => {
  let competition = _ref2.competition,
    compName = _ref2.compName;
  return React.createElement(React.Fragment, null, React.createElement(CompetitionLogo, {
    competition: competition
  }), React.createElement("div", {
    className: "competition-overview-hero-content"
  }, React.createElement("h2", {
    className: "overview-hero-title"
  }, React.createElement("span", null, "".concat(compName, " \xE4r h\xE4r!"))), React.createElement("p", {
    className: "overview-hero-sub"
  }, React.createElement("span", null, "Anm\xE4l dig till t\xE4vlingen")), React.createElement(Registration, {
    competition: competition
  })));
};
const UserHasNoBet = _ref3 => {
  let competition = _ref3.competition,
    compName = _ref3.compName;
  return React.createElement(React.Fragment, null, React.createElement(CompetitionLogo, {
    competition: competition
  }), React.createElement("div", {
    className: "competition-overview-hero-content"
  }, React.createElement("h2", {
    className: "overview-hero-title"
  }, React.createElement("span", null, "Du deltar i ".concat(compName))), React.createElement("p", {
    className: "overview-hero-sub"
  }, React.createElement("span", null, "Omg\xE5ngen \xE4r st\xE4ngd f\xF6r k\xF6p."), React.createElement("span", null, "Gl\xF6m inte att l\xE4mna in ditt spel i tid."))));
};
const UserHasBet = _ref4 => {
  let competition = _ref4.competition;
  const _ref5 = (competition === null || competition === void 0 ? void 0 : competition.details) || {},
    firstDrawNumber = _ref5.firstDrawNumber,
    currentDrawNumber = _ref5.currentDrawNumber;
  const currentGameTitle = useMemo(() => {
    if (firstDrawNumber && currentDrawNumber) {
      const round = currentDrawNumber - firstDrawNumber + 1;
      return React.createElement(React.Fragment, null, React.createElement("span", null, "F\xF6lj ditt spel live i"), React.createElement("span", null, "".concat(ordinalNumber(round), " omg\xE5ngen")));
    }
    return React.createElement("span", null, "F\xF6lj ditt spel live!");
  }, [currentDrawNumber, firstDrawNumber]);
  return React.createElement(React.Fragment, null, React.createElement(CompetitionLogo, {
    competition: competition
  }), React.createElement("div", {
    className: "competition-overview-hero-content"
  }, React.createElement("h2", {
    className: "overview-hero-title"
  }, currentGameTitle), React.createElement(VisitGameButton, {
    competition: competition
  })));
};
const CompetitionOpenDrawLive = _ref6 => {
  let competition = _ref6.competition,
    userState = _ref6.userState;
  const compName = resolveCompetitionName(competition);
  const renderContentBasedOnUserState = state => {
    switch (state) {
      case IS_NOT_REGISTERED:
        return React.createElement(UserNotRegistered, {
          competition: competition,
          compName: compName
        });
      case HAS_NO_CURRENT_BET:
        return React.createElement(UserHasNoBet, {
          competition: competition,
          compName: compName
        });
      case HAS_CURRENT_BET:
        return React.createElement(UserHasBet, {
          competition: competition
        });
      default:
        return React.createElement(UserNotLoggedIn, {
          competition: competition,
          compName: compName
        });
    }
  };
  return React.createElement("div", {
    className: clx('competition-overview-hero competition-open-draw-live', userState)
  }, renderContentBasedOnUserState(userState));
};
setGlobal('svs.components.marketplaceCompetition.overviewHero.content.CompetitionOpenDrawLive', CompetitionOpenDrawLive);

 })(window);